import styled from 'styled-components';
import BoltPill from '../pill/Pill';
var FilterPills = styled.ul.withConfig({
  displayName: "FilterPillsstyles__FilterPills",
  componentId: "kqqf3x-0"
})(["display:inline-flex;"]);
var Pill = styled(BoltPill).withConfig({
  displayName: "FilterPillsstyles__Pill",
  componentId: "kqqf3x-1"
})(["margin:0 2.5px;"]);
var ListItem = styled.li.withConfig({
  displayName: "FilterPillsstyles__ListItem",
  componentId: "kqqf3x-2"
})(["all:inherit;"]);
export { FilterPills, Pill, ListItem };